import { render, staticRenderFns } from "./AamsDocumentRegDispatchApproval.vue?vue&type=template&id=5a384244&scoped=true&"
import script from "./AamsDocumentRegDispatchApproval.vue?vue&type=script&lang=js&"
export * from "./AamsDocumentRegDispatchApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a384244",
  null
  
)

export default component.exports